import { motion } from 'framer-motion';

const DifferentialsSection = () => {
  const differentials = [
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Total',
      description: 'Veículos segurados e equipe treinada para garantir proteção completa'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atendimento Premium',
      description: 'Suporte dedicado e personalizado para cada cliente'
    },
    {
      icon: 'ri-time-line',
      title: 'Pontualidade',
      description: 'Compromisso com horários e prazos estabelecidos'
    }
  ];

  return (
    <section className="bg-white py-32 lg:py-40">
      <div className="w-full px-12 lg:px-20">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-6"
          >
            Nossos Diferenciais
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-3xl lg:text-4xl font-medium text-primary leading-tight mb-6"
          >
            Por que escolher o<br />
            <span className="text-secondary/40">Grupo Prime?</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-secondary text-lg leading-relaxed"
          >
            Compromisso com excelência e qualidade em cada operação
          </motion.p>
        </div>

        {/* Differentials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {differentials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <h3 className="text-lg font-semibold text-primary mb-2">
                {item.title}
              </h3>
              <p className="text-secondary text-sm leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;
